Vue.component('streamerBattleQueue', {
  template: templates.streamerBattleQueue,
  data() {
    return {
      model: {
        battles: [],
        hasResults: false,
        isLoading: false
      },
    };
  },
  mounted() {
    const c = this;
    c.get();
    c.connect();
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {

        const messageData = event.data;

        try {

          const parsedData = JSON.parse(messageData);
          if((parsedData.message === 'streamer_battle_queue' || parsedData.message === 'streamer_team_battle_cancelled' || parsedData.message === 'streamer_team_battle_started' || parsedData.message === 'streamer_team_battle_requeued' ) && parsedData.channelId === utils.cookies.get('channelId')){
              c.model.hasResults = false;
              c.model.isLoading = false;
              c.model.battles = [];
              c.get();
          }

        } catch (error) {
          console.error('Error parsing message data:', error);
        }
      
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get() {
      const c = this;
      let data = {};

      teamBattleService
        .getStreamerQueue()
        .then(function (response) {
          console.log(response.data)
          c.model.hasResults = true;
          
          c.model.isLoading = true;
          c.model.battles = response.data

         console.log(c.model)
        })
        .catch(function (error) {
          c.model.hasResults = false;
          c.model.isLoading = true;
          // setTimeout(function () {
          //   c.get();
          // }, 10000);
        });
    },
    getTwitchName(data, ids = [], results = []) {
      const c = this;
      let url = `${apiUrl}users?`;

      if (ids.length == 0) {
        for (let i in data) {
          let user1 = data[`${i}`].user1TwitchId;
          let user2 = data[`${i}`].user2TwitchId;
          if (user1 == null) {
            ids.push(data[`${i}`].user1TwitchId);
          } else {
            data[`${i}`].user1TwitchDisplayName =
              data[`${i}`].twitch1DisplayName;
          }

          if (user2 == null) {
            ids.push(data[`${i}`].user2TwitchId);
          } else {
            data[`${i}`].user2TwitchDisplayName =
              data[`${i}`].twitch2DisplayName;
          }
        }
      }

      for (let i = 0; i < 100; i++) {
        if (ids[i]) {
          url = `${url}id=${ids[i]}&`;
          ids.splice(i, 1);
        }
      }

      if (!ids.length) {
        c.model.battles = data;

        setTimeout(function () {
          c.get();
        }, 10000);

        return;
      }

      axios
        .get(url, {
          headers: {
            'Client-ID': clientId,
            Authorization: `Bearer ${utils.cookies.get('access_token')}`,
          },
        })
        .then(function (response) {
          results = results.concat(response.data.data);
          if (ids.length > 0) {
            c.getTwitchName(data, ids, results);
          } else {
            c.processTwitchNames(data, results);
          }
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            authentication.refreshAccessToken({
              callback: function () {
                c.getTwitchName(data);
              },
            });
          }
        });
    },
    start(data) {
      const c = this;
 
       teamBattleService.save({ id: data.id })
          .then(function (response) {
             const messageData = {
                message: 'streamer_team_battle_started',
                channelId: utils.cookies.get('channelId'),
                username1: data.streamerAccept[0].twitchDisplayName,
                username2: data.streamerChallenge[0].twitchDisplayName,
              };

          
              c.ws.send(JSON.stringify(messageData));
          })
          .catch(function (error) {
            //console.log(error);
          });
    },
    cancel(data) {
      const c = this;

      var result = confirm(
          'Are you sure you want to remove this battle from the queue?'
        );
        if (result == true) {
          teamBattleService
            .cancel({ id: data.id })
            .then(function (response) {
                const messageData = {
                    message: 'streamer_team_battle_cancelled',
                    channelId: utils.cookies.get('channelId'),
                    username1: data.streamerAccept[0].twitchDisplayName,
                    username2: data.streamerChallenge[0].twitchDisplayName,
                };

                c.ws.send(JSON.stringify(messageData));
            })
            .catch(function (error) {
              //console.log(error);
            });
        }
    },
     getPlayerDisplayNames(battle, player){
        const c = this;
        if(player === 1){
          return [
            battle.user1TwitchDisplayName,
            battle.user2TwitchDisplayName,
            battle.user3TwitchDisplayName,
            battle.user4TwitchDisplayName
          ].filter(name => name).join(', '); 
        }
        else{
          return [
            battle.user5TwitchDisplayName,
            battle.user6TwitchDisplayName,
            battle.user7TwitchDisplayName,
            battle.user8TwitchDisplayName
          ].filter(name => name).join(', '); 
        }
  

      }
  },
});
